/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Auth_Code_Resend_WaitInputs */

const en_us2_auth_code_resend_wait = /** @type {(inputs: Auth_Code_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend in ${i?.seconds} s`)
};

const pt_br2_auth_code_resend_wait = /** @type {(inputs: Auth_Code_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reenviar em ${i?.seconds} s`)
};

const es_419_auth_code_resend_wait = /** @type {(inputs: Auth_Code_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reenviar en ${i?.seconds} s`)
};

const pt_pt2_auth_code_resend_wait = /** @type {(inputs: Auth_Code_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reenviar em ${i?.seconds} s`)
};

const fr_fr2_auth_code_resend_wait = /** @type {(inputs: Auth_Code_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renvoyer dans ${i?.seconds} s`)
};

const de_de2_auth_code_resend_wait = /** @type {(inputs: Auth_Code_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erneut senden in ${i?.seconds} s`)
};

const it_it2_auth_code_resend_wait = /** @type {(inputs: Auth_Code_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rinvia tra ${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "Resend in {seconds} s" |
*
* @param {Auth_Code_Resend_WaitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_resend_wait = /** @type {((inputs: Auth_Code_Resend_WaitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_Resend_WaitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_resend_wait(inputs)
	if (locale === "es-419") return es_419_auth_code_resend_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_resend_wait(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_resend_wait(inputs)
	if (locale === "de-DE") return de_de2_auth_code_resend_wait(inputs)
	if (locale === "it-IT") return it_it2_auth_code_resend_wait(inputs)
	return en_us2_auth_code_resend_wait(inputs)
});
export { auth_code_resend_wait as "auth.code_resend_wait" }